import * as React from 'react';
import Filter from '../components/filters/filter';
import { FiltersContainerViewProps } from '../components/filters/container';   

const FiltersListView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <>
            <ul className="filters-list" data-accordion-content-id="filters">
                <Filter propertyToFilter="month" filterName={props.text.dateFilterTitleText} noSelectionText={props.text.dateAllSelectionText} />
                <Filter propertyToFilter="accessibilityTypes" filterName={props.text.accessFilterTitle} noSelectionText={props.text.accessAllSelectionText} />
                <Filter propertyToFilter="dayOfWeek" filterName={props.text.dayOfWeekFilterTitleText} noSelectionText={props.text.dayOfWeekFilterTitleText} />
                <Filter propertyToFilter="categories" filterName={props.text.categoryFilterTitleText} noSelectionText={props.text.categoryFilterTitleText} />
            </ul>          
        </>
    )
}

const FiltersContainerView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
         <FiltersListView {...props }></FiltersListView>
    );
}

export default FiltersContainerView;